import { render } from "./PollsList.vue?vue&type=template&id=d63bef2e&scoped=true"
import script from "./PollsList.vue?vue&type=script&lang=js"
export * from "./PollsList.vue?vue&type=script&lang=js"

import "./PollsList.vue?vue&type=style&index=0&id=d63bef2e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d63bef2e"]])

export default __exports__